<template>
  <div class="text-center py-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-2">Loading...</p>
  </div>
</template>

<style>
.spinner-border {
  width: 2rem;
  height: 2rem;
}
</style>
